"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var config = {
  name: 'EVgo React Material-UI Components',
  shortName: 'EVgo Material Components',
  description: 'An EVgo dependency for React Material-UI components.',
  brandColors: {
    primary: '#002B39',
    secondary: '#1FA3FF'
  },
  colors: {
    accentBlue: '#32647E',
    accentYellow: '#F8E71C',
    accentOrange: '#F5A623'
  }
};
var _default = config;
exports["default"] = _default;